module.exports = __webpack_public_path__ + "img/J12324.b0381499.png";